// src/api/todoCategoryApi.js
import apiClient from './axios'; 

const todoCategoryApi = {
  getAll: async () => {
    const response = await apiClient.get('/tealtik/fetch_categories');
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/tealtik/categories', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.put(`/tealtik/categories/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    await apiClient.delete(`/tealtik/categories/${id}`);
    return id;
  },

  exportCsv: async () => {
    // If backend doesn't have export yet — you can remove this or mock it
    const response = await apiClient.get('/tealtik/categories/export', {
      responseType: 'blob',
    });
    return response.data;
  },
};

export default todoCategoryApi;